import React from 'react';
import PageLoader from 'app/components/PageLoader';
import PaginatedTable from 'app/components/table/PaginationTable';
import { eventHeader } from 'app/constants/table-header-constants';
import useEventManagement from './useEventManagement';

const EventManagement = () => {
  const {
    isdeleteFiltering,
    totalNumber,
    filteredData,
    sectionObj,
    handleDelete,
    handleEdit,
    inputChangeHandler,
    changeHandler,
    pageLoading,
    fetchEventData,
    currentPage,
    dataPerPage,
    pageCount,
    paginationHandler,
    navigate,
  } = useEventManagement();

  return (
    <>
      <div className='cms-content__container'>
        <PaginatedTable
          sectionObj={sectionObj}
          columns={eventHeader}
          data={filteredData}
          fetchData={fetchEventData}
          fulldata={filteredData}
          currentPage={currentPage}
          dataPerPage={dataPerPage}
          totalNumber={totalNumber}
          pageCount={pageCount}
          paginationHandler={paginationHandler}
          handleDelete={handleDelete}
          handleEdit={handleEdit}
          handleNew={() => {}}
          inputChangeHandler={inputChangeHandler}
          changeHandler={changeHandler}
          pageLoading={pageLoading}
          navigate={navigate}
          isdeleteFiltering={isdeleteFiltering}
        />
      </div>
      {pageLoading === true && <PageLoader pageLoading={pageLoading} />}
    </>
  );
};

export default EventManagement;
